(() => {
  const root = document.querySelector('.nano-returns');
  if (!root) return;
  root.querySelectorAll('.returns-faq-list details').forEach((item) => {
    const summary = item.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(item.open));
    item.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(item.open)));
  });
  const copyButton = root.querySelector('#copy-address');
  const address = root.querySelector('#return-address');
  const status = root.querySelector('#copy-status');
  if (copyButton && address && status) {
    copyButton.hidden = false;
    copyButton.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(address.innerText); status.textContent = copyButton.dataset.copied; }
      catch { const range = document.createRange(); range.selectNodeContents(address); const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); status.textContent = copyButton.dataset.selected; }
    });
  }
  const printButton = root.querySelector('#print-policy');
  let printStates = [];
  const openForPrint = () => { if (printStates.length) return; printStates = [...root.querySelectorAll('.returns-faq-list details')].map((el) => ({ el, open: el.open })); printStates.forEach(({ el }) => { el.open = true; }); };
  const restoreAfterPrint = () => { printStates.forEach(({ el, open }) => { el.open = open; }); printStates = []; };
  if (printButton) { printButton.hidden = false; printButton.addEventListener('click', () => { openForPrint(); window.print(); }); }
  window.addEventListener('beforeprint', openForPrint);
  window.addEventListener('afterprint', restoreAfterPrint);
})();
